import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import QuestionMark from "../../../assets/Icon/QuestionMark";
import CustomInput from "../../UI/CustomInput";
import PopoverView from "../../UI/PopoverView";
import Dropdown from "../../UI/Dropdown";
import useHover from "../../../hooks/useHover";
import TooltipButton from "../../UI/TooltipButton";
import { useSelector } from "react-redux";
import { calculatorPlatformsSelector } from "../../../redux/selectors/CalculatorSelectors";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";

const StepFive = ({
  isCalculate,
  setIsCalculate,
  data,
  setData,
  calculatorType,
  isEditMode,
  setIsEditMode,
  handleBlur,
  dataError,
  setDataError,
  handleEnter,
  isWagePerHour,
  isStep2,
}) => {
  const {
    serviceProviders,
    transactionFee,
    creditCardFee,
    listingFee,
    depopFee,
    commissionFee,
    depopShippingLabelFee,
    stockLevel,
    depopLevel,
    goatLevel,
    averagePerHour,
    paymentProcessing,
    selling,
    serviceFee,
    otherFee,
    profit,
  } = data;
  const isProfileMarginType = calculatorType === "calc-5";
  const [hovered, eventHandlers] = useHover();
  const platforms = useSelector(calculatorPlatformsSelector);

  const history = useHistory();
  const { location } = history as any;
  const statevars = location?.state as any;
  const [isTutorial, setIsTutorial] = useState(false);
  const handleServiceSelect = ({ value, subOptionVal }) => {
    if (!value) {
      setDataError({ ...dataError, serviceProvidersError: true });
    } else {
      setDataError({ ...dataError, serviceProvidersError: false });
    }
    const updateData = {
      ...data,
      serviceProviders: value,
    };
    if (value === "StockX") {
      updateData.stockLevel = subOptionVal?.value;
    } else {
      updateData.stockLevel = "";
    }
    if (value === "Depop") {
      updateData.depopLevel = subOptionVal?.value;
    } else {
      updateData.depopLevel = "";
    }
    if (value === "GOAT") {
      updateData.goatLevel = subOptionVal?.value;
    } else {
      updateData.goatLevel = "";
    }
    const dataVal = {
      ...updateData,
      shipping: "0",
      averagePerHour: "0",
      creditCardFee: "0",
      depopShippingLabelFee: "0",
      transactionFee: "0",
      commissionFee: "0",
      listingFee: "0",
      paymentProcessing: "0",
      selling: "0",
      serviceFee: "0",
      otherFee: "0",
      profit: "0",
      isEdit: false,
    };
    if (calculatorType === "calc-2") {
      dataVal.profit = profit;
      dataVal.listingPrice = "0";
    }
    setData(dataVal);
    setIsCalculate(false);
  };

  useEffect(() => {
    if (statevars?.state?.isTutorial) {
      setIsTutorial(true);
    }
  }, [statevars]);

  useEffect(() => {
    handleBlur();
  }, [serviceProviders, stockLevel, depopLevel, goatLevel]);

  const handleChange = ({ target: { value, name } }) => {
    setData({ ...data, [name]: value, isEdit: !isStep2 });
  };

  useEffect(() => {
    if (isEditMode) {
      setData({
        ...data,
        transactionFee: 0,
      });
    }
  }, [isEditMode]);

  const hintPopover = () => {
    switch (serviceProviders) {
      case "Etsy":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Etsy charges sellers several fees to list their product:
            </p>
            <ul className="pl-3">
              <li>A listing fee of $0.20</li>
              <li>A transaction fee of 6.5% of the listing price</li>
              <li>A credit card fee of 3% of the listing price plus $0.25 </li>
            </ul>
          </div>
        );
      case "Poshmark":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Poshmark charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>
                A commission fee of $2.95 for a sale under $15, or a commission
                fee of 0.2% of the sale for sales greater than or equal to $15{" "}
              </li>
            </ul>
          </div>
        );
      case "Depop":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Depop charges sellers several fees to list their product:
            </p>
            <ul className="pl-3">
              <li>A fee of 10% of the listing price</li>
              <li>
                A transaction fee of 3.49% of the listing price plus $0.49
              </li>
              <li>An optional and variable shipping label cost </li>
            </ul>
          </div>
        );
      case "Shopify":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Shopify charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>A credit card fee of 2.9% of the sale price plus $0.30 </li>
            </ul>
          </div>
        );
      case "Poshmark":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Shopify charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>A credit card fee of 2.9% of the sale price plus $0.30 </li>
            </ul>
          </div>
        );
      case "StockX":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              StockX charges sellers a fee to list their product:
            </p>
            <ul className="pl-3 mb-0 pb-0">
              <li>A transaction fee that varies by seller level </li>
            </ul>

            <ul className="pl-4">
              <li>Level 1: 10.0% </li>
              <li>Level 2: 9.5% </li>
              <li>Level 3: 9.0% </li>
              <li>Level 4: 8.5% </li>
              <li>Level 5: 8.0% </li>
            </ul>
          </div>
        );
      case "GOAT":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              GOAT charges sellers several fees to list their product:
            </p>
            <ul className="pl-3">
              <li>A transaction fee of 9.5% of the listing price plus $5 </li>
              <li>A credit card fee of 2.9% cash out *Min cash out is $25</li>
            </ul>
          </div>
        );
      case "Instagram/Facebook Marketplace":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              There are no fees on Instagram or Facebook Marketplace.
            </p>
          </div>
        );

      case "Mercari":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Mercari charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>
                A payment processing fee of 2.9% of the listing price plus $0.5{" "}
              </li>
              <li>A selling fee of 2.9% of the listing price </li>
            </ul>
          </div>
        );

      case "Grailed":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Grailed charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>
                A payment processing fee of 4.99% of the listing price plus
                $0.49{" "}
              </li>
              <li>A selling fee of 4.99% of the listing price </li>
            </ul>
          </div>
        );

      case "Vinted":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              Vinted charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>A transaction fee of 0.7% of the listing price </li>
              <li>A order value of 5% of the listing price </li>
            </ul>
          </div>
        );

      case "OfferUp":
        return (
          <div className="position-relative popover-info-wrapper">
            <p className="mb-1 font-weight-bold">
              OfferUp charges sellers a fee to list their product:
            </p>
            <ul className="pl-3">
              <li>
                A service charge of greater than or equal to $1.99 then service
                charge is $1.99 otherwise service charge of 12.9% of the listing
                price
              </li>
            </ul>
          </div>
        );
    }
  };

  const popover = (
    <Popover
      style={{ marginLeft: 0 }}
      id="popover-basic"
      className="all-popover"
    >
      <Popover.Title
        as="h3"
        className="popover-title d-flex justify-content-between"
      >
        <span>Compare Expected Profit </span>
      </Popover.Title>
      <Popover.Content className="popover-content">
        Compare expected profits across multiple platforms.
      </Popover.Content>
      <Button
        onClick={() => {
          history.push(statevars?.state?.prevPagePath, { isLastStep: true });
        }}
        className="popover-button"
      >
        next
      </Button>
    </Popover>
  );
  return (
    <div>
      {isWagePerHour ? (
        <p className="mt-5 mb-0 font-weight-bold">
          You earn an average of $(blank) per hour.
          <TooltipButton title={""} placement="top" icon={<QuestionMark />} />
        </p>
      ) : (
        <p className="mt-5 mb-0 font-weight-bold">
          {isProfileMarginType
            ? "What fees were paid to service providers?"
            : "What fees were paid to marketplaces?"}

          <TooltipButton
            title="Select the platform you are listing your product(s) on. "
            placement="top"
            icon={<QuestionMark />}
          />
        </p>
      )}
      <>
        {isTutorial ? (
          <OverlayTrigger
            show={isTutorial}
            placement="right"
            overlay={popover}
            rootClose={true}
            rootCloseEvent="mousedown"
            trigger="click"
          >
            <Dropdown
              label="Select marketplace or selling platform"
              onChange={handleServiceSelect}
              value={serviceProviders}
              optionVal={stockLevel}
              options={platforms}
              disabled={statevars?.state?.isTutorial}
            />
          </OverlayTrigger>
        ) : (
          <div>
            <Dropdown
              label="Select marketplace or selling platform"
              onChange={handleServiceSelect}
              value={serviceProviders}
              optionVal={stockLevel}
              options={platforms}
              disabled={false}
            />
          </div>
        )}
        <>
          {serviceProviders && !isProfileMarginType && (
            <>
              {isWagePerHour ? (
                <div>
                  <div className="mt-3 mb-1 product-label">
                    Average per hour
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="font-currency mr-2">$</span>
                    <CustomInput
                      formControlClass="time-input"
                      placeholder="00.00"
                      min="0"
                      type="number"
                      name="averagePerHour"
                      readOnly={true}
                      value={averagePerHour}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyPress={handleEnter}
                    />
                  </div>
                </div>
              ) : (
                <>
                  {serviceProviders === "Etsy" && (
                    <>
                      <div className="mt-3 mb-1 product-label">Listing Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="listingFee"
                          readOnly={isEditMode}
                          value={listingFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Transaction Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="transactionFee"
                          readOnly={isEditMode}
                          value={transactionFee}
                          disabled={
                            ["Poshmark"].includes(isEditMode) && isEditMode
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Credit Card Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="creditCardFee"
                          readOnly={isEditMode}
                          value={creditCardFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "Depop" && (
                    <>
                      <div className="mt-3 mb-1 product-label">Depop Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="depopFee"
                          readOnly={isEditMode}
                          value={depopFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Shipping Label Cost
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="depopShippingLabelFee"
                          // readOnly={isEditMode}
                          value={depopShippingLabelFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Transaction Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="transactionFee"
                          readOnly={isEditMode}
                          value={transactionFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "StockX" && (
                    <>
                      <div className="mt-3 mb-1 product-label">
                        {stockLevel} Transaction Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00"
                          min="0"
                          type="number"
                          name="transactionFee"
                          readOnly={isEditMode}
                          value={transactionFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "Poshmark" &&
                    calculatorType !== "calc-3" && (
                      <>
                        <div className="mt-3 mb-1 product-label">
                          Marketplace Fee
                        </div>
                        <div className="d-flex align-items-center">
                          <span className="font-currency mr-2">$</span>
                          <CustomInput
                            formControlClass="time-input"
                            placeholder="00.00"
                            min="0"
                            type="number"
                            name="commissionFee"
                            readOnly={isEditMode}
                            value={commissionFee}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyPress={handleEnter}
                          />
                        </div>
                      </>
                    )}

                  {serviceProviders === "Shopify" && (
                    <>
                      <div className="mt-3 mb-1 product-label">
                        Credit Card Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="creditCardFee"
                          readOnly={isEditMode}
                          value={creditCardFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "GOAT" && (
                    <>
                      <div className="mt-3 mb-1 product-label">
                        Transaction Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="transactionFee"
                          readOnly={isEditMode}
                          value={transactionFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Credit Card Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="creditCardFee"
                          readOnly={isEditMode}
                          value={creditCardFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "Mercari" && (
                    <>
                      <div className="mt-3 mb-1 product-label">Listing Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="listingFee"
                          readOnly={isEditMode}
                          value={listingFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Payment processing
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="paymentProcessing"
                          readOnly={isEditMode}
                          value={paymentProcessing}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">Selling Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="selling"
                          readOnly={isEditMode}
                          value={selling}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "Grailed" && (
                    <>
                      <div className="mt-3 mb-1 product-label">Listing Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="listingFee"
                          readOnly={isEditMode}
                          value={listingFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Payment processing
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="paymentProcessing"
                          readOnly={isEditMode}
                          value={paymentProcessing}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">Selling Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="selling"
                          readOnly={isEditMode}
                          value={selling}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "OfferUp" && (
                    <>
                      <div className="mt-3 mb-1 product-label">Service Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="serviceFee"
                          readOnly={isEditMode}
                          value={serviceFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "Vinted" && (
                    <>
                      <div className="mt-3 mb-1 product-label">
                        Transaction Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="transactionFee"
                          // readOnly={isEditMode}
                          value={transactionFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders === "Custom" && (
                    <>
                      <div className="mt-3 mb-1 product-label">Listing Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="listingFee"
                          // readOnly={isEditMode}
                          value={listingFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Transaction Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="transactionFee"
                          // readOnly={isEditMode}
                          value={transactionFee}
                          disabled={
                            ["Poshmark"].includes(isEditMode) && isEditMode
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">
                        Credit Card Fee
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="creditCardFee"
                          // readOnly={isEditMode}
                          value={creditCardFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">Service Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="serviceFee"
                          // readOnly={isEditMode}
                          value={serviceFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                      <div className="mt-3 mb-1 product-label">Other Fee</div>
                      <div className="d-flex align-items-center">
                        <span className="font-currency mr-2">$</span>
                        <CustomInput
                          formControlClass="time-input"
                          placeholder="00.00"
                          min="0"
                          type="number"
                          name="otherFee"
                          // readOnly={isEditMode}
                          value={otherFee}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyPress={handleEnter}
                        />
                      </div>
                    </>
                  )}

                  {serviceProviders &&
                    !["Custom", "Depop", "Vinted"].includes(
                      serviceProviders,
                    ) && (
                      <>
                        <div className="mt-3 mb-2 product-label">Shipping</div>
                        <div className="d-flex align-items-center">
                          <span className="font-currency mr-2">$</span>
                          <CustomInput
                            formControlClass="time-input"
                            placeholder="00.00"
                            min="0"
                            type="number"
                            name="shipping"
                            value={data.shipping}
                            // readOnly={isEditMode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyPress={handleEnter}
                          />
                        </div>
                      </>
                    )}

                  <p className="pt-3 mb-0" id="PopoverViewWrapper">
                    {hintPopover() && (
                      <small>
                        <PopoverView
                          isOpen={hovered}
                          positions={["left"]}
                          content={hintPopover()}
                          reposition
                          boundaryElement={document.getElementById(
                            "PopoverViewWrapper",
                          )}
                        >
                          <div className="d-inline-block" {...eventHandlers}>
                            <IconButton
                              id="how-to-calc-btn"
                              disabled={!hovered}
                            >
                              <QuestionMark />
                            </IconButton>
                          </div>
                        </PopoverView>
                        How did we calculate this?
                      </small>
                    )}
                  </p>
                </>
              )}
            </>
          )}
        </>
      </>
    </div>
  );
};
export default StepFive;
